var exports = {
  "n": "x31de4314--03394b--link",
  "x": "x31de4314--03394b--button",
};

module.exports = exports;
